module.exports = __webpack_public_path__ + "static/media/backend.dd692967.jpg";